var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "tapcoinIndex",
    class: _vm.isMobile && 'wap'
  }, [[_c('div', {
    staticClass: "bg",
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/index-bg-1.jpg`)})`
    }
  }), _c('div', {
    staticClass: "bg1",
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg-1.jpg`)})`
    }
  }), _vm.isShowTurboScreen ? _c('div', {
    staticClass: "turboBg"
  }, _vm._l(2, function (_) {
    return _c('span', {
      style: {
        backgroundImage: `url(${require(`@images/${_vm.theme}/index-icon-small-coin.png`)})`
      }
    });
  }), 0) : _vm._e()], _c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "icons"
  }, [_c('div', {
    staticClass: "icon",
    on: {
      "click": function ($event) {
        return _vm.onSkip('rank');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/level/${_vm.getLevelName(_vm.userData.user_level)}.png`)
    }
  })]), _c('div', {
    staticClass: "icon",
    on: {
      "click": function ($event) {
        return _vm.onSkip(_vm.userData.user_group_id <= 0 ? 'join' : 'squad', _vm.userData.user_group_id);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/index-icon-squad-1.png`)
    }
  })]), _c('div', {
    staticClass: "icon",
    on: {
      "click": function ($event) {
        return _vm.onSkip('pph');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/index-icon-pph.png`)
    }
  })])]), _c('div', {
    staticClass: "r-btns"
  }, [_vm.setting.socials.channel ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.onSkip('wallet');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/index-icon-wallet.png`)
    }
  }), _vm._v(" " + _vm._s(_vm.$lang('Wallet')) + " ")]) : _vm._e()])]), _c('div', {
    staticClass: "c-btns"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.onSkip('sign');
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/index-btn-icon-1.png`)
    }
  })]), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$lang('Daily Login')))])]), _c('div', {
    staticClass: "btn",
    class: !_vm.setting.lucky_code_id && 'dis'
  }, [_c('div', {
    staticClass: "icon",
    on: {
      "click": function ($event) {
        return _vm.onSkip('lucky');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/index-btn-icon-2.png`)
    }
  })]), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$lang('Lucky Code')))]), _c('div', {
    staticClass: "tip"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/30tip.png`)
    }
  })])]), _c('div', {
    staticClass: "btn",
    on: {
      "click": function ($event) {
        return _vm.onSkip('mine');
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/index-btn-icon-3.png`)
    }
  })]), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$lang('Daily Bounty')))])])]), _c('div', {
    staticClass: "total",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "icon",
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/index-icon-small-coin.png`)})`
    }
  }), _c('div', {
    ref: "aaaaaaaaaa",
    staticClass: "total__value",
    class: !_vm.isMobile && 'pc'
  }, [!_vm.isIos ? [_c('CountUp', {
    attrs: {
      "num": _vm.userData.coin
    }
  })] : [_vm._v(_vm._s(_vm._f("toThousands")(_vm.userData.coin)))]], 2)]), _c('div', {
    staticClass: "sub",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "sub-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/icon-pph-2.png`)
    }
  }), _vm._v(" " + _vm._s(_vm.$lang("Profit per hour")) + " "), _c('div', {
    staticClass: "sub__value"
  }, [_vm._v("+" + _vm._s(_vm._f("toThousands")(_vm.hourEearnings)) + " ")])])])]), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "coin",
    on: {
      "touchstart": function ($event) {
        _vm.isMobile && _vm.handleClick($event);
      },
      "click": function ($event) {
        !_vm.isMobile && _vm.handleClick($event);
      }
    }
  }, [_c('my-tile', {
    attrs: {
      "max": 15
    }
  }, [_c('div', {
    ref: "coinRef",
    staticClass: "coin-main",
    class: !_vm.isMobile && 'pc',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/index-icon-big-coin.png`)})`
    }
  })])], 1)]), _c('div', {
    staticClass: "bottomX",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => {}).apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-main"
  }, [_c('div', {
    staticClass: "progress__text"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/sd.png`),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.userData.power)), _c('i', [_vm._v("/" + _vm._s(_vm.userData.power_max))])])]), _c('div', {
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "bar-main",
    style: {
      left: -100 + Number(_vm.progressBar) + '%'
    }
  })])]), _c('div', {
    staticClass: "btns"
  }, [_c('div', {
    staticClass: "btn btn-frens",
    on: {
      "click": function ($event) {
        return _vm.onSkip('frens');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/btn-icon-frens.png`),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.$lang("Frens")) + " ")]), _c('div', {
    staticClass: "btn btn-boosts",
    on: {
      "click": function ($event) {
        return _vm.onSkip('boost');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/btn-icon-boost.png`),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.$lang("Boosts")) + " ")])])]), _c('m-menu')], 1), [_c('div', {
    ref: "blockRef",
    staticClass: "block",
    on: {
      "touchstart": function ($event) {
        _vm.isMobile && _vm.handleClick($event);
      },
      "click": function ($event) {
        !_vm.isMobile && _vm.handleClick($event);
      }
    }
  }, _vm._l(_vm.blockAnimList, function (item, index) {
    return _c('span', {
      key: index,
      class: item.bool && 'active',
      style: {
        left: item.x,
        top: item.y
      }
    }, [_vm._v("+" + _vm._s(_vm.turbo_temp_times <= 0 ? _vm.userData.multi_tap : _vm.userData.multi_tap * _vm.turbo_temp_times))]);
  }), 0)], _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShowTurboIcon,
      expression: "isShowTurboIcon"
    }],
    ref: "turboRef",
    staticClass: "turbo",
    on: {
      "touchstart": function ($event) {
        _vm.isMobile && _vm.isShowTurboIcon && _vm.onShowTurboScreen();
      },
      "click": function ($event) {
        $event.stopPropagation();
        !_vm.isMobile && _vm.isShowTurboIcon && _vm.onShowTurboScreen();
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/turbo.png`),
      "alt": ""
    }
  })]), _c('pop-robot', {
    attrs: {
      "show": _vm.popRobotShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popRobotShow = $event;
      }
    }
  }), _c('pop-adv-tip', {
    attrs: {
      "show": _vm.popAdvTipShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popAdvTipShow = $event;
      }
    }
  }), _c('pop-login-reward', {
    attrs: {
      "show": _vm.popLoginRewardShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popLoginRewardShow = $event;
      }
    }
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };